import React from "react";
import styles from "../../../styles/pages/profile/ProfilePage.module.css";

const CommentsViewSkeleton = () => {
  return (
    <div className={styles.contentSection}>
      <div className={styles.sectionHeader}>
        <div>
          <div className={`${styles.skeleton} ${styles.skeletonTitle}`}></div>
          <div
            className={`${styles.skeleton} ${styles.skeletonSubtitle}`}
          ></div>
        </div>
      </div>

      <div className={styles.commentsGrid}>
        {[1, 2, 3].map((i) => (
          <div key={i} className={styles.commentCard}>
            <div className={styles.commentCardHeader}>
              <div
                className={`${styles.skeleton} ${styles.skeletonText}`}
                style={{ width: "60%", height: "20px" }}
              ></div>
              <div
                className={`${styles.skeleton} ${styles.skeletonText}`}
                style={{ width: "25%" }}
              ></div>
            </div>
            <div
              className={`${styles.skeleton} ${styles.skeletonText}`}
              style={{ width: "100%", height: "60px", marginTop: "10px" }}
            ></div>
            <div className={styles.commentCardFooter}>
              <div
                className={`${styles.skeleton} ${styles.skeletonText}`}
                style={{ width: "30%" }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommentsViewSkeleton;
